<template>
	<ApiErrorCard v-if="store.error" :error="store.error" />
	<NotificationList v-else class="overflow-y-scroll min-h-64 max-h-96">
		<NotificationListEntry
			v-for="notification in store.all"
			:key="notification.id"
			:read="notification.read"
			@click="onNotificationClick(notification)"
		>
			<component
				:is="getComponent(notification.type)"
				:notification="notification"
			/>
		</NotificationListEntry>

		<template #empty>
			<div class="flex items-center justify-center gap-1 min-h-56">
				<AppIcon name="inbox" class="text-2xl text-[var(--text-secondary)]" />
				<p class="text-center text-text-secondary">Geen notificaties</p>
			</div>
		</template>
	</NotificationList>
</template>

<script lang="ts" setup>
import type { Notification, NotificationTypes } from "@/generatedApi";
import { useNotificationStore } from "@/store/useNotificationStore";
import type { Component } from "vue";
import NotificationTypeBase from "./NotificationType/NotificationTypeBase.vue";
import NotificationTypeLoanApplication from "./NotificationType/NotificationTypeLoanApplication.vue";

const store = useNotificationStore();

const onNotificationClick = async (notification: Notification) => {
	if (!notification.read) {
		await store.read(notification.id);
	}
};

const notificationComponents: Partial<Record<NotificationTypes, Component>> = {
	loanApplication: NotificationTypeLoanApplication,
};

function getComponent(type: NotificationTypes) {
	if (notificationComponents[type] !== undefined) {
		return notificationComponents[type];
	}
	return NotificationTypeBase;
}
</script>
